var default_styles_default = {
  "button_container": "Gm5bq",
  "button_text": "xS0vt",
  "button_size_content": "_5Tmj9"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
